export default "__VITE_ASSET__RWfM5uTp__"